/**
 * form-modal
 */

import Component, { subscribe } from "../../js/lib/component";
import Page from "../page/page";

const classList = {
  root: ".js-form-modal",
  close: ".js-form-modal-close"
};

export default class FormModal extends Component {
  init() {
    this.$.openOuter = $("[data-form-modal-open]");
    this.$.closeOuter = $("[data-form-modal-close]");
    this.modalName = this.$.root.data("form-modal-name");
  }
  events() {
    this.$.openOuter.on("click", e => {
      const $target = $(e.currentTarget);
      const targetModalName = $target.data("form-modal-open");

      if (targetModalName && targetModalName === this.modalName) {
        e.preventDefault();
        this.show();
      }
    });

    this.$.closeOuter.on("click", e => {
      const $target = $(e.currentTarget);
      const targetModalName = $target.data("form-modal-close");

      if (targetModalName && targetModalName === this.modalName) {
        e.preventDefault();
        this.close();
      }
    });

    this.$.close.on("click", e => {
      e.preventDefault();
      this.close();
    });

    subscribe("page:esc", this.close.bind(this));
  }
  close() {
    this.$.root.fadeOut(200, () => {
      Page.bodyOverflowDisable();
    });
  }
  show() {
    this.$.root.fadeIn(200);
    Page.bodyOverflowEnable();
  }
}

Component.mount(FormModal, {
  name: "FormModal",
  classList,
  state: {}
});
